import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AffiliateLinks from "./Components/AffiliateLinks/AffiliateLinks";

export default function App() {
  return (
    <Router>
      <div>
        {/* Define your routes */}
        <Routes>
          <Route path="/links" element={<AffiliateLinks />} />
          <Route path="/" element={<AffiliateLinks />} />
        </Routes>
      </div>
    </Router>
  );
}